import React from 'react';
import styled, {css} from 'styled-components';

import {useOnClickOutside} from 'web-app/react/hooks/use-on-click-outside';

interface Props {
    className?: string;
    showArrow?: boolean;
    direction?: Direction;
    position?: Position;
    onClickOutside?: () => void;
}

const Popover: React.FC<React.PropsWithChildren<Props>> = ({
    className,
    showArrow = true,
    direction = 'NORTH',
    position,
    children,
    onClickOutside,
}) => {
    const ref = React.useRef<HTMLDivElement>(null);
    const handleClickOutside = React.useCallback(() => {
        if (onClickOutside) {
            onClickOutside();
        }
    }, [onClickOutside]);

    useOnClickOutside(ref, handleClickOutside, undefined, true);

    return (
        <StyledPopover ref={ref} className={className} showArrow={showArrow} direction={direction} position={position}>
            {children}
        </StyledPopover>
    );
};

export type Direction = 'NORTH' | 'SOUTH';
export type Position = 'right' | 'center' | 'left';

interface StyledPopoverProps {
    showArrow: boolean;
    direction: Direction;
    position?: Position;
}
const StyledPopover = styled.div<StyledPopoverProps>`
    ${props =>
        props.showArrow
            ? css`
                  position: relative;
                  background: ${props.theme.background};
                  border: none;
                  box-shadow ${props.theme.shadow.two};
                  border-radius: 4px;
                  &:before {
                    content: '';
                    pointer-events: none;
                    position: absolute;
                    top: 0;
                    right: 9px;
                    height: 10px;
                    width: 10px;
                    background: ${props.theme.backgroundHover};
                    border: 1px solid ${props.theme.delimiter};
                    z-index: -1;
                    transform: translate(-50%, -50%) rotate(45deg);
                  }
              `
            : ''}
    ${props =>
        props.direction === 'SOUTH'
            ? css`
                  top: 100% !important;
              `
            : ''}

    ${props =>
        props.position === 'center'
            ? css`
                  :after,
                  :before {
                      left: 50%;
                  }
              `
            : ''}
`;

export default Popover;
